import { Component, OnInit } from '@angular/core';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { PeticionesHttpBackEndService } from '../@core/mock/peticiones-http-backend.service';
import { MENU_ITEMS } from './pages-menu';
import { MENU_ITEMS_ADMIN } from './pages-menu-admin';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-sample-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-sample-layout>
  `,
  providers: [PeticionesHttpBackEndService]
})
export class PagesComponent implements OnInit{

  constructor(private authService: NbAuthService,public _PeticionesHttpBackEndService: PeticionesHttpBackEndService){
    this.menu = MENU_ITEMS;
  }

  RequestResult:any;
  menu:any;

  ngOnInit(){
    this.authService.getToken()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
       
        this._PeticionesHttpBackEndService.getUsuario().subscribe(
          result => {
            this.RequestResult = result;
            if (this.RequestResult.Entidad._rol_id == 3){
              // Si es usuario normal
              this.menu = MENU_ITEMS;
            }else if (this.RequestResult.Entidad._rol_id == 1 || this.RequestResult.Entidad._rol_id == 2){
              this.menu = MENU_ITEMS_ADMIN;
            }
          },
          error => {}
        );

      }
    }); 
  }
}
